module.exports = __webpack_public_path__ + "img/8f36dcc521834ab9baf560c12ad0da23-1440.2e478c94.jpg";